/**
 * The main app; a lean file to manage everything else in a ordered way
 */
import { initGlobalDOM } from './app.dom-global';
import { initScopedDOM } from './app.dom-scoped';
import { loadModules } from './app.module-loader';
import { initAlpine } from './app.alpine.init';
import { initHTMX } from './app.htmx.init';


/**
 * Alpine (global)
 */
initAlpine();


/**
 * Site global DOM work
 */
initGlobalDOM();


/**
 * Site scoped DOM work
 */
initScopedDOM();


/**
 * Site modules
 */
loadModules();


/**
 * Finally HTMX with loadModules for adding modules to loaded HTMX
 */
initHTMX(initScopedDOM);